// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loading_loadingWrapper__3QfE7","spinner":"loading_spinner__WX43o","rotate":"loading_rotate__hEhwr","path":"loading_path__2Irls","dash":"loading_dash__3CN1K"};